/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-06-29 17:11:56
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-09-22 16:02:36
 * @FilePath: \crm-product\found\views\tpm\views\budget\cost_warning\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from '../form';
import {
  ProcessLog,
} from '../../../../../../modules';

export default {
  name: 'cost_warning',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
    ProcessLog,
  },
  created() {
    this.getConfigList('main-list');
  },
  methods: {
    afterGetList() {
      this.tableData = this.tableData.map((v) => ({
        ...v,
        highestRate: `${v.highestRate ? `${v.highestRate}%` : '0%'}`,
      }));
    },
    // 控制按钮显示
    clickVisible({
      row,
      val: {
        code,
      },
    }) {
      const {
        approveStatus,
        processCode,
      } = row;
      // 审批通过 approved,审批中 approving,活动关闭 closed,流程追回 interrupt,驳回 rejected
      if (code === 'process_log' && !processCode) {
        return false;
      }
      if (
        approveStatus
        && code === 'edit'
        && (approveStatus === 'approving'
          || approveStatus === 'approved')
      ) {
        return false;
      }
      return true;
    },
    modalClick({
      val,
      row,
    }) {
      this.formConfig = {};
      this.formName = 'Form';
      if (['add', 'view', 'edit', 'copy'].includes(val.code)) {
        this.formConfig = {
          code: val.code,
          row,
        };
        if (val.code === 'add') {
          this.modalConfig.title = '新增';
        } else if (val.code === 'view') {
          this.modalConfig.title = '查看';
        } else if (val.code === 'edit') {
          this.modalConfig.title = '编辑';
        } else if (val.code === 'copy') {
          this.modalConfig.title = '复制';
        }
        this.openFull();
      } else if (val.code === 'enable') {
        if (this.selection.length > 0) {
          this.$confirm('确认要启用吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              request.post('/tpm/tpmIndicatorController/enable', this.selection).then((res) => {
                if (res.success) {
                  this.$message({
                    type: 'success',
                    message: '操作成功',
                  });
                  this.getList();
                  this.clearSelection();
                }
              });
            });
        } else {
          this.$message('请至少选择一条数据！');
          return false;
        }
      } else if (val.code === 'disable') {
        if (this.selection.length > 0) {
          this.$confirm('确认要禁用吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              request.post('/tpm/tpmIndicatorController/disable', this.selection).then((res) => {
                if (res.success) {
                  this.$message({
                    type: 'success',
                    message: '操作成功',
                  });
                  this.getList();
                  this.clearSelection();
                }
              });
            });
        } else {
          this.$message('请至少选择一条数据！');
          return false;
        }
      } else if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: {
            processNo: row.processCode,
          },
        };

        this.modalConfig.title = '流程日志';

        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },

    // 提交审批回调
    onSubmit(params) {
      const configParams = {
        ...params,
        code: 'approve',
      };

      this.$emit('approve', configParams);
    },
  },
};
